<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">管理コンソール</span>
        </div>
      </div>
      <button class="back-btn" v-on:click="$router.push('/menu')">← メニューへ戻る</button>
    </header>
    <main class="main-content">
      <div class="white-card">
        <h1 class="page-title">お知らせ一覧</h1>
        <table class="data-table">
          <thead>
            <tr>
              <th>お知らせ日時</th>
              <th>タイトル</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="info in infos" :key="info.id">
              <td>{{ info.issue_date }}</td>
              <td>{{ info.title }}</td>
              <td>
                <button class="btn-primary" v-on:click="to_info(info.id)">編集</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import store from "@/store";

export default {
  data: function () {
    return {
      infos: []
    }
  },
  async mounted() {
    await axios.get("/infos").then((response) => {
      this.infos = response.data
    });
  },
  methods: {
    to_info: function (info_id) {
      router.push("/info/" + info_id)
    },
    logout: function () {
      store.dispatch("logout")
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background: #DDE2EC;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
  background: #1E2A3A;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header-brand { display: flex; align-items: center; gap: 12px; }

.brand-mark {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, #4F8EF7, #7C5CFC);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem; font-weight: 800; color: #fff;
}

.brand-info { display: flex; flex-direction: column; line-height: 1.2; }
.brand-name { font-size: 1rem; font-weight: 700; color: #fff; }
.brand-sub  { font-size: 0.68rem; color: #8A9BB0; }

.back-btn {
  padding: 8px 20px; border-radius: 8px;
  border: 1.5px solid #94A3B8; background: transparent;
  color: #94A3B8; font-size: 0.85rem; font-weight: 600;
  cursor: pointer; font-family: inherit;
  transition: background 0.2s, color 0.2s;
}
.back-btn:hover { background: #94A3B8; color: #1E2A3A; }

.main-content {
  max-width: 960px; margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.10);
  padding: 32px 40px;
}

.page-title {
  font-size: 1.3rem; font-weight: 700;
  color: #1E293B; margin: 0 0 24px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #E2E8F0;
}

.data-table { width: 100%; border-collapse: collapse; }
.data-table th {
  text-align: left; padding: 12px 16px;
  background: #F8FAFC; color: #475569;
  font-size: 0.8rem; font-weight: 700;
  border-bottom: 2px solid #E2E8F0;
}
.data-table td {
  padding: 14px 16px; border-bottom: 1px solid #F1F5F9;
  font-size: 0.9rem; color: #334155;
}
.data-table tr:hover td { background: #F8FAFC; }

.btn-primary {
  padding: 8px 18px; border-radius: 8px; border: none;
  background: #3B82F6; color: #fff;
  font-size: 0.85rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background 0.2s;
}
.btn-primary:hover { background: #2563EB; }
</style>
